import eventBus from '@probatix/common/utils/eventBus'

export interface LocalStorageInterface {
  clear: () => any
  get: (key: string) => any
  remove: (key: string) => any
  set: (key: string, value: any) => void
}

const LocalStorage: LocalStorageInterface = {
  clear: () => {
    window.localStorage.clear()
    eventBus.clear()
  },
  get: (key: string) => window.localStorage.getItem(key),
  remove: (key: string) => {
    window.localStorage.removeItem(key)
    eventBus.dispatch(key, 'remove')
  },
  set: (key: string, value: any) => {
    window.localStorage.setItem(key, value)
    eventBus.dispatch(key, value)
  },
}

export default LocalStorage
